import { diskStorage, memoryStorage } from 'multer';
// import { extname, resolve } from 'path';
import { ConfigService } from '@nestjs/config';
import { UtilsService } from '../shared/utils/utils.service';

export const createStorage = async (
  configService: ConfigService,
  utilsService: UtilsService,
) => {
  const storageMode = configService.get<string>('config.storage.mode');

  return storageMode === 'local'
    ? diskStorage({
        destination: configService.get<string>('config.storage.path'),
        // destination: (req, file, cb) => {
        //   cb(null, resolve(__dirname, '..') + '/public/uploads');
        // },
        filename: (req, file, cb) => {
          cb(null, utilsService.createFileName(file));
        },
      })
    : memoryStorage();
};
